function getChangelogs() {
    const CHANGELOGS = [
        {version: "v1.1.2b", release: "Current Release", date: "Nov 02, 2026", dimensions: "35.6MB", highlights: "Bugs fixed: now the session saving works correctly. Corrected a memory leak. The maximise button now works correctly. Removed white screen while loading.",
            added: [],
            
            improved: [
                {text: "GUI improvments: now the maximise button works correctly."},
            ],

            fixed: [
                {text: "Session saving bug: now the feature works correctly."},
                {text: "Major bug while logging out: corrected a memory leak."},
                {text: "Removed white screen while loading."},
            ]
        },
        {version: "v1.1.2", release: "Stable Release", date: "Nov 01, 2026", dimensions: "35.6MB", highlights: "Rewrote entire codebase. Fixed bugs. Added the setting to launch the game at boot. Added car damage screen. Added indicators support.",
            added: [
                {text: "Car damage screen on the dashboard."},
                {text: "Setting to launch game at boot."},
                {text: "Full indicators support."}
            ],
            
            improved: [
                {text: "Code rebuilt from scratch."},
                {text: "Now the button 'View detailed changelogs' works just fine."},
            ],

            fixed: [
                {text: "Minor bugs."},
                {text: "Fixed Leaderboard bug: now the pit counter is working correctly."}
            ]
        },
        {version: "v1.1.1", release: "Stable Release", date: "Mar 18, 2026", dimensions: "27.3MB", highlights: "Fixed major leaderboard bugs. It now updates every session change. Added the ability to save the session just completed (BETA FEATURE)",
            added: [
                {text: "Save just completed session (BETA)."},
                {text: "UDP connection status (now visible also in the dashboard)."},
                {text: "Game status (now visible also in the dashboard)."},
                {text: "Fetch of the client version."}
            ],
            
            improved: [],

            fixed: [
                {text: "Major Leaderboard bug: It now updates every session change."}
            ]
        }, 
        {version: "v1.1.0", release: "Stable Release", date: "Feb 22, 2026", dimensions: "27.2MB", highlights: "Added full Leaderboard support (pro feature). Code rebuilt from scratch to fully optimize the performance using multi-processes logics.",
            added: [
                {text: "Full Leaderboard support (pro feature)."}
            ],
            
            improved: [
                {text: "Code rebuilt from scratch to fully optimize the performance using multi-processes logics."},
                {text: "Minor GUI changes."}
            ],

            fixed: [
                {text: "Major bug while closing the UDP connection from games."}
            ]
        }, 

        {version: "v1.0.4", release: "Stable Release", date: "Feb 13, 2026", dimensions: "27.2MB", highlights: "Added internal Updater and minors changes to the gui.",
            added: [
                {text: "Internal Updater."}
            ],
            
            improved: [
                {text: "Minor GUI changes."}
            ],

            fixed: [
                {text: "Infinite loading screen."}
            ]
        }, 

        {version: "v1.0.3", release: "Stable Release", date: "Feb 11, 2026", dimensions: "14.6MB", highlights: "Added Fuel Strategy by Simone Manzoni and optimized performaces using multi-thread and multi-processes logics.",
            added: [
                {text: "Fuel Strategy by Simone Manzoni (pro feature)."}
            ],
            
            improved: [
                {text: "Optimized performaces using multi-thread and multi-processes logics."}
            ],

            fixed: [
                {text: "Minor GUI errors."}
            ]
        }, 

        {version: "v1.0.2", release: "Stable Release", date: "Feb 07, 2026", dimensions: "14.4MB", 
            added: [
                {text: "Full Brake Bias compatibility for all type of cars."}
            ],
            
            improved: [
                {text: "Minor performaces optimization"}
            ],

            fixed: [
                {text: "Major issue fixed: fatal error ACC screen while entering a new session with the client opened."}
            ]
        },

        {version: "v1.0.1", release: "Stable Release", date: "Feb 01, 2026", dimensions: "14.3MB", 
            added: [
                {text: "New GUI."}
            ],
            
            improved: [],

            fixed: []
        }
    ]

    return CHANGELOGS
}

export default getChangelogs;